if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.index = 0;
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-step]');
        const thumb = event.target.closest('[data-go]');
        if (step) this.select(this.index + Number(step.dataset.step));
        if (thumb) this.select(Number(thumb.dataset.go));
      });
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open') || event.target.closest('video, iframe, model-viewer, input, textarea')) return;
        if (event.key === 'Tab') {
          const controls = [...this.querySelectorAll('button, [tabindex], video[controls], iframe')].filter((el) => el.tabIndex >= 0 && !el.disabled && el.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) { event.preventDefault(); first?.focus(); }
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      const stage = this.querySelector('.he-gallery__stage');
      stage.addEventListener('touchstart', (event) => {
        this.touch = event.touches.length === 1 && !event.target.closest('deferred-media, product-model, button')
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      stage.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 1) this.touch = null;
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { this.touch = null; }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      removeTrapFocus();
      this.querySelector('[id^="ModalClose-"]').focus();
    }
    showActiveMedia() {
      const slides = [...this.querySelectorAll('[data-slide-id]')];
      const id = this.openedBy?.getAttribute('data-media-id');
      this.select(Math.max(0, slides.findIndex((slide) => slide.dataset.slideId === id)));
    }
    select(index) {
      const slides = [...this.querySelectorAll('[data-slide-id]')];
      if (!slides.length) return;
      window.pauseAllMedia();
      this.index = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      const thumbs = [...this.querySelectorAll('[data-go]')];
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === this.index)));
      const current = thumbs[this.index];
      const strip = this.querySelector('.he-gallery__thumbs');
      if (current && strip) strip.scrollLeft = current.offsetLeft - strip.offsetLeft - (strip.clientWidth - current.clientWidth) / 2;
      this.querySelector('.he-gallery__count').textContent = `${this.index + 1} / ${slides.length}`;
      slides[this.index].querySelectorAll('img').forEach((img) => { img.loading = 'eager'; img.sizes = '(min-width: 750px) calc(100vw - 136px), calc(100vw - 16px)'; });
    }
  });
}
